'use client';

import { Link } from '@ui/link';

export default function NavbarWithMenuLink({
  link: { label, href },
}: {
  link: {
    label: string;
    href: string;
  };
}) {
  return (
    <Link
      key={label}
      href={href}
      onClick={() => {
        const checkbox = document.getElementById('menu-toggle') as HTMLInputElement | null;
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
        }
      }}
    >
      {label}
    </Link>
  );
}
